import { siteInfo } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-3/5">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 leading-snug mb-6">
              The Largest Spreadsheet Database <br />&amp; Shopping Guide
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              Hipobuy Spreadsheet Hub is a structured product discovery resource that helps shoppers organize, compare, and research products more efficiently. Instead of manually searching thousands of products, users can explore categorized spreadsheets containing curated information, buying guides, and comparison resources.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="border-r border-background-200/70 pr-4">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">14+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Product Categories</p>
              </div>
              <div className="border-r border-background-200/70 pr-4">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">1000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Curated Products</p>
              </div>
              <div className="border-r border-background-200/70 pr-4">
                <p className="text-3xl md:text-4xl font-bold text-primary-500">Daily</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Updated Spreadsheets</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-bold text-primary-500">Free</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Access For All</p>
              </div>
            </div>
          </div>
          <div className="lg:w-2/5 relative min-h-[280px] md:min-h-[340px] rounded-lg overflow-hidden bg-accent-100/40">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20watercolor%20wash%20in%20warm%20coral%20peach%20and%20sand%20tones%2C%20organic%20fluid%20shapes%20blending%20seamlessly%2C%20minimalist%20artistic%20composition%2C%20gentle%20texture%20and%20gradient%2C%20modern%20brand%20decoration%20element%2C%20clean%20airy%20aesthetic%20with%20subtle%20depth&width=800&height=700&seq=about-decor-v4&orientation=portrait"
              alt="Hipobuy Spreadsheet brand decoration"
              title="Hipobuy Spreadsheet Hub"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}